var i = function () {
	if (layData.shownag == 'show') {
		var ts = Date.now()
		// setInterval( function(){
		//     var $nag = jQuery('._ts_'+ts);
		//     if( $nag.length === 0 ) {
		jQuery('body').prepend(
			'<a class="_ts_' +
				ts +
				'" href="https://laytheme.com" target="_blank">Created with Laytheme.com</a>' +
				'<style>' +
				'@keyframes fadeIn {' +
				'0% { opacity: 0; }' +
				'100% { opacity: 1; }' +
				'}' +
				'._ts_' +
				ts +
				'{' +
				'color:black;text-decoration:none;border-bottom:none;' +
				'letter-spacing:0.01em;' +
				'animation: fadeIn 0.2s;' +
				'animation-fill-mode: forwards;' +
				'background:white;' +
				'position:fixed;' +
				'bottom:10px;' +
				'right:10px;' +
				'color:black;' +
				'z-index:99999999999999999999999999;' +
				'font-size:12px;' +
				'line-height:25px;' +
				'height:25px;' +
				'padding-left:10px;' +
				'padding-right:10px;' +
				// +'box-shadow: 0px 0px 5px rgba(0,0,0,0.4);'
				'border:1px solid rgb(230,230,230);' +
				'border-radius:20px;' +
				'font-family: Helvetica, sans-serif;' +
				'transition: opacity 200ms ease;' +
				'}' +
				'</style>'
		)
		//     }
		// }, 1000 );
	}
}

var nag_controller = {
	i: function () {
		i()
	},
}
export default nag_controller
